/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { NumericFormat } from 'react-number-format';

import { styles } from './styles';

function NumberFormatCustom(props) {
	const { inputRef, onChange, ...other } = props;
	return (
		<NumericFormat
			{...other}
			getInputRef={inputRef}
			onValueChange={values => {
				onChange({
					target: {
						value: values.value
					}
				});
			}}
			decimalScale={2}
			allowNegative="false"
			suffix={'%'}
		/>
	);
}

const DiscountCodeForm = ({ handlePropChange, name, code, percentage, recurring, children }) => {
	const handleChange = prop => event => {
		if (prop === 'recurring') {
			handlePropChange(prop, event.target.checked);
			return;
		}
		if (prop === 'percentage') {
			handlePropChange(prop, event.target.value);
		}
		handlePropChange(prop, event.target.value);
	};
	return (
		<Grid container spacing={1}>
			<Grid item xs={12}>
				<FormControl sx={styles.formControl}>
					<TextField
						value={name}
						error={name.length === 0}
						onChange={handleChange('name')}
						autoComplete="name"
						name="name"
						variant="filled"
						required
						fullWidth
						id="name"
						label="Name"
						helperText="Ex: 2022 Holiday Code"
						autoFocus
					/>
				</FormControl>
			</Grid>
			<Grid item xs={12}>
				<FormControl sx={styles.formControl}>
					<TextField
						value={code}
						error={code.length === 0}
						onChange={handleChange('code')}
						autoComplete="code"
						name="code"
						variant="filled"
						required
						fullWidth
						id="code"
						label="Code"
						helperText="HOLIDAY10"
					/>
				</FormControl>
			</Grid>
			<Grid item xs={6}>
				<FormControl sx={styles.formControl}>
					<TextField
						variant="filled"
						label="Discount Percentage"
						value={percentage}
						onChange={handleChange('percentage')}
						id="formatted-numberformat-input"
						InputProps={{
							inputComponent: NumberFormatCustom
						}}
					/>
				</FormControl>
			</Grid>
			<Grid item xs={6}>
				<FormGroup row>
					<FormControlLabel
						control={<Checkbox checked={recurring} onChange={handleChange('recurring')} name="recurring" />}
						label="Does this Discount apply on renewal?"
					/>
				</FormGroup>
			</Grid>
			{children}
		</Grid>
	);
};
export default DiscountCodeForm;
